import axios from 'axios'

// we always override the base URL in storybook
// try{} to make sure this doesn't cause issues in browsers

// @ts-expect-error - this is a hack to test that the storybook preview is running
const isStorybookEnv = window?.IS_STORYBOOK === true

export const apiBaseURL = isStorybookEnv
  ? import.meta.env.VITE_STORYBOOK_API_URL
  : import.meta.env.VITE_API_URL

const axiosInstance = axios.create({
  baseURL: apiBaseURL,
})
const axiosLoggingModes = ['development', 'test', 'mock', 'storybook']
if (axiosLoggingModes.includes(import.meta.env.MODE)) {
  axiosInstance.interceptors.request.use((request) => {
    console.log(
      'Starting Request',
      JSON.stringify(
        {
          headers: request.headers,
          url: request.url,
          method: request.method,
          baseURL: request.baseURL,
          data: request.data,
        },
        null,
        2
      )
    )
    return request
  })
}
export default axiosInstance
